import { useQuery, type ApolloError } from "@apollo/client";
import type { IntegratedDataSourcesResponse } from "./types";
import { GET_DATA_SOURCES } from "./APIs/DataSourcesApi";

export const DatasourceCheckConnectionStatusEnum = {
  CONNECTING: "CONNECTING",
  SUCCESS: "SUCCESS",
  FAILED: "FAILED",
} as const;

export interface UseIntegratedDataSourcesResult {
  integratedDataSources: IntegratedDataSourcesResponse | undefined;
  integratedDataSourcesError: ApolloError | undefined;
  loading: boolean;
}

const useIntegratedDataSources = (
  withLastCollectionTime = false,
  withCollectionState = false,
  filters: Record<string, unknown> = {},
  useCache = false
): UseIntegratedDataSourcesResult => {
  const {
    data: integratedDataSources,
    error: integratedDataSourcesError,
    loading,
  } = useQuery<IntegratedDataSourcesResponse>(GET_DATA_SOURCES, {
    fetchPolicy: useCache ? "cache-first" : "no-cache",
    variables: {
      with_collection_state: withCollectionState,
      filters,
      with_collection_start_time: withLastCollectionTime,
    },
  });

  return { integratedDataSources, integratedDataSourcesError, loading };
};

export default useIntegratedDataSources;
